module.exports = __webpack_public_path__ + "assets/filter-free-delivery-95aefe.svg";